import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SupplierAuthService } from '../services/supplier-auth.service';
import { from } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

export const supplierAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(SupplierAuthService);
  const token = authService.getToken();
  
  console.log('[SupplierAuthInterceptor] URL da requisição:', req.url, 'Método:', req.method);
  
  // Add token if request is to /api/v1/supplier, /api/v1/fornecedores or /api/v1/account
  if (token && (req.url.includes('/api/v1/supplier') || req.url.includes('/api/v1/fornecedores') || req.url.includes('/api/v1/account'))) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  // Add clientIp to ANY POST request (especialmente para /claim)
  if (req.method === 'POST') {
    const isClaimRequest = req.url.toLowerCase().includes('claim');
    console.log('[SupplierAuthInterceptor] POST request - isClaim:', isClaimRequest, 'URL:', req.url);
    
    if (isClaimRequest && req.body) {
      console.log('[SupplierAuthInterceptor] ⚠️ INTERCEPTANDO CLAIM REQUEST');
      
      return from(fetch('https://api.ipify.org?format=json').then(res => res.json())).pipe(
        tap((ipInfo: any) => console.log('[SupplierAuthInterceptor] IP obtido:', ipInfo.ip)),
        switchMap((ipInfo: any) => {
          const bodyObj = typeof req.body === 'string' ? JSON.parse(req.body) : req.body;
          const payload: any = {
            ...bodyObj,
            clientIp: ipInfo.ip
          };
          console.log('[SupplierAuthInterceptor] ✅ Payload com clientIp:', JSON.stringify(payload));
          
          const finalReq = req.clone({
            body: payload,
            setHeaders: {
              'X-User-IP': ipInfo.ip
            }
          });
          return next(finalReq);
        }),
        catchError(error => {
          console.error('[SupplierAuthInterceptor] ❌ Erro ao buscar IP:', error);
          return next(req);
        })
      );
    }
  }

  return next(req);
};
